export const formatWithComma = (str: string): string => {
  return str.replace('.', ',');
};
